import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

const ManagePhotosSkeleton = () => (
  <Box>
    {/* Header bar */}
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
      <Skeleton variant="rounded" width={160} height={36} sx={{ borderRadius: '8px' }} />
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Skeleton variant="rounded" width={110} height={36} sx={{ borderRadius: '8px' }} />
        <Skeleton variant="rounded" width={110} height={36} sx={{ borderRadius: '8px' }} />
      </Box>
    </Box>
    {/* Photo grid */}
    <Grid container spacing={2}>
      {Array.from({ length: 6 }).map((_, i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <Skeleton variant="rounded" height={180} sx={{ borderRadius: '12px' }} />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default ManagePhotosSkeleton;
